import {
    GET_ALL_TESTS_FAIL,
    GET_ALL_TESTS_REQUEST,
    GET_ALL_TESTS_SUCCESS
} from "../constants/testConstants"
import axios from 'axios'

export const testMerge = (template, narrative) => async(dispatch) => {
    dispatch({
        type: GET_ALL_TESTS_REQUEST
    })

    try {

        const config = {
            headers:{
                'Content-type': 'application/json',
            }
        }

        const { data } = await axios.post(
            process.env.REACT_APP_GOLANGAPI + '/api/test/merge',
            {
                template: template,
                narrative: narrative
            },
            config
        )

        dispatch({
            type: GET_ALL_TESTS_SUCCESS,
            payload: data,
        })
    }
    catch (error) {
        dispatch({
            type: GET_ALL_TESTS_FAIL,
            payload: error.response && error.response.data
            ? error.response.data
            : error.message,
        })
    }
}